module.exports = __webpack_public_path__ + "static/7-Swimming-Pool-View-with-Decks-3e95964d7132314f22dbede83bf9c430.jpg";